<div class="container">

  <app-header-dialog [iconName]="'format_list_bulleted'">
    {{ local_title }}
  </app-header-dialog>

  <form name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>list</mat-icon>
          <div>Categoria</div>
        </ng-template>


        <div class='tab-content-id'>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
              O Nome é obrigatório
            </mat-error>
          </mat-form-field>

          <br>
          <hr>
          <div style="display: flex; flex-direction: row; justify-content:space-between;">
            <mat-checkbox color='primary' [formControl]="entityForm.controls.partner">
              Sócio
            </mat-checkbox>

            <mat-checkbox color='primary' [formControl]="entityForm.controls.hidden">
              Oculto
            </mat-checkbox>

            <mat-checkbox color='primary' [formControl]="entityForm.controls.sponsor">
              Patrocinador
            </mat-checkbox>

            <mat-checkbox color='primary' [formControl]="entityForm.controls.front_desk">
              Exibir na loja
            </mat-checkbox>

            <mat-checkbox color='primary' [formControl]="entityForm.controls.annuity">
              Cobrar anuidade
            </mat-checkbox>
          </div>
          <hr>
          <br>

          <div
            style="display: flex; justify-content: space-between; padding: 10px 10px 5px 10px; background-color: whitesmoke;">
            <div>
              Documentos
            </div>
            <a mat-button (click)="openDocDialog(null)" style='width:60px;'>
              <mat-icon color='primary'>add_circle_outline</mat-icon>
            </a>
          </div>

          <div style="height: 240px; overflow: auto; padding: 10px; border: solid 1px silver;">
            <div *ngFor="let item of data.docList">
              <div style="display: flex; justify-content: space-between;">
                <div style='width:100%;'>
                  {{item.doc}}
                </div>
                <a mat-button (click)="openDocDialog(item)" style='width:60px;'>
                  <mat-icon class='icon-info'>info_outline</mat-icon>
                </a>
                <a mat-button (click)="removeDocument(item.id)" style='width:60px;'>
                  <mat-icon class='icon-delete'>delete_outline</mat-icon>
                </a>
              </div>
              <hr>
            </div>

          </div>

        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>document_scanner</mat-icon>
          <div>Documentos</div>
        </ng-template>

        <div class='tab-content-id'>



          <mat-form-field class="full-width" appearance="outline">
            <label>Documentos</label>
            <textarea class='text-area' matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.documents" autocomplete="off">
                          </textarea>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <label>Documentos Inglês</label>
            <textarea class='text-area' matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.documents_en" autocomplete="off">
                      </textarea>
          </mat-form-field>



        </div>

      </mat-tab>

    </mat-tab-group>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>